<template lang="pug">
v-dialog(v-model="show" persistent max-width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown" )
    RemoveFromArchiveDialog(v-if="showRemoveDialog"
      :show="showRemoveDialog"
      :selectedBoarder="selectedBoarder"
      :boarderGroupList="boarderGroupList"
      :customerList="customerList"
      :saveInProgress="saveInProgress"
      @save="saveDialog"
      @close="onCloseDialog"
      )
    v-snackbar( v-model="snackbar" :timeout="snackbarTimeout" :color="snackbarColor" ) {{snackBarText}}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs"
          @click="snackbar = false")
          v-icon fal fa-times

    v-card.d-flex.flex-column
        v-card-title.headline {{ $t('addBoarderDialog.dialogTitle') }}
        v-card-text.flex-shrink-0.flex-grow-1.card-body(:style="{height: mainBodyHeight}")
            v-tabs(v-model="tab")
                v-tab {{ $t('addBoarderDialog.createNewBoarder') }}
                v-tab {{ $t('boarderManagementPage.archivedBoarderLabel') }}
                v-tab-item
                    v-container.pa-0
                        v-form(ref="form" v-model="isFormValid" :lazy-validation="true" :disabled="isSaveInProgress")
                            v-row
                                v-col(cols="6")
                                    v-text-field(
                                        v-model="currentFirstName"
                                        :label="$t('addBoarderDialog.firstNameFieldLabel') + ' *'" outlined prepend-icon="fas fa-user" required
                                    :dense="$vuetify.breakpoint.mdAndUp" :rules="givenNameRules"
                                    )
                                v-col(cols="6")
                                    v-text-field(
                                        v-model="currentFamilyName"
                                        :label="$t('addBoarderDialog.familyNameFieldLabel') + ' *'" outlined required
                                    :dense="$vuetify.breakpoint.mdAndUp" :rules="familyNameRules"
                                    )

                            v-row
                                v-col(cols="12" md="6")
                                    v-text-field(
                                        v-model="currentEmail"
                                        :label="$t('addBoarderDialog.emailFieldLabel') + ' *'" outlined prepend-icon="fas fa-envelope"
                                        :dense="$vuetify.breakpoint.mdAndUp" :rules="emailRules"
                                    )
                                v-col(cols="12" md="6")
                                    v-text-field(
                                        v-model="currentPhoneNumber"
                                        :label="$t('addBoarderDialog.phoneFieldLabel')" outlined prepend-icon="fas fa-phone"
                                        :dense="$vuetify.breakpoint.mdAndUp"
                                    )

                            v-row
                                v-col.pb-0(cols="12" md="6")
                                    v-select(
                                        v-model="currentCustomer"
                                        append-icon="fas fa-chevron-down" :label="$t('addBoarderDialog.customerFieldLabel') + ' *'" prepend-icon="fas fa-user-tie"
                                        outlined item-value="id" item-text="name" return-object
                                    :items="customerList" :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading"
                                        :rules="currentCustomerRules"
                                    )
                                v-col.pb-0(cols="12" md="6")
                                    v-select(
                                        v-model="currentBoarderGroup"
                                        append-icon="fas fa-chevron-down" :label="$t('addBoarderDialog.boarderGroupFieldLabel') + ' *'"
                                        outlined item-value="id" item-text="name" return-object prepend-icon="fas fa-house-user"
                                        :items="filteredBoarderGroupList" :disabled="isBoarderGroupSelectorDisabled"
                                        :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading" :rules="currentBoarderGroupRules")
                        v-row.ma-0
                          v-spacer
                          v-btn(
                            color="primary" :disabled="!isFormValid" :loading="isSaveInProgress"
                            @click="onSubmitButtonClick"
                          ) {{ $t('addBoarderDialog.submitButtonLabel') }}
                v-tab-item
                    v-card.elevation-0()
                        v-card-text.px-0
                            v-form(ref="form" v-model="isForm1Valid" lazy-validation :disabled="inProgress")
                              v-row.ma-0
                                  v-col(cols="12")
                                      v-text-field(outlined :label="$t('addBoarderDialog.firstNameFieldLabel')"  v-model="name")
                              v-row.ma-0.title(v-if="name && !getfilteredArchivedBoarder.length" justify="center" )
                                span.text-center {{ $t('addBoarderDialog.searchBoarderNameIsNotExist') }}
                            v-row.ma-0
                                v-col.pa-0(cols="12" sm="12" md="6")
                                    v-list(v-if="archivedBoarder && name" dense )
                                        v-list-item(v-for="(item,idx) in getfilteredArchivedBoarder" :key="idx" @click="showBoarderFormClick(item)")
                                            v-row.ma-0
                                                v-col(col="6" )
                                                    v-list-item-content.pt-0.pb-0 {{item.person.firstName}} {{item.person.familyName}}
                                                    v-list-item-content {{item.customer.name}} ({{item.boarderGroupCollection[0].name}})
                                v-col(cols="12" sm="12" md="6" v-if="selectedBoarder && !$vuetify.breakpoint.smAndDown")
                                    v-form(ref="form" v-model="isForm2Valid" :lazy-validation="true" :disabled="inProgress")
                                        v-row
                                            v-col(cols="12")
                                              v-text-field(
                                                v-model="selectedBoarder.person.firstName + ' ' + selectedBoarder.person.familyName"
                                                :label="$t('addBoarderDialog.nameFieldLabel')" outlined prepend-icon="fas fa-user"
                                                readonly
                                              )
                                        v-row
                                            v-col.pb-0(cols="12" )
                                              v-select(
                                                v-model="customer"
                                                append-icon="fas fa-chevron-down" :label="$t('addBoarderDialog.customerFieldLabel') + ' *'" prepend-icon="fas fa-user-tie"
                                                outlined item-value="id" item-text="name"
                                                :items="customerList" :loading="isLoading"
                                                :rules="currentCustomerRules" @change="changeCustomer"
                                              )
                                            v-col.pb-0(cols="12" )
                                              v-select(
                                                v-model="group"
                                                append-icon="fas fa-chevron-down" :label="$t('addBoarderDialog.boarderGroupFieldLabel') + ' *'"
                                                outlined item-value="id" item-text="name" prepend-icon="fas fa-house-user"
                                                :items="filteredGroupList"
                                                :loading="isLoading" :rules="currentBoarderGroupRules" :disabled="boarderGroupSelectorDisabled"
                                              )
                                        v-row.ma-0
                                            v-spacer
                                            v-btn(color="primary" @click="onRemoveFromArchiveButtonClick" :disabled="!isForm2Valid" :loading="saveInProgress") {{ $t('boarderManagementPage.removeFromArchiveButtonLabel') }}

        v-divider
        v-card-actions
            v-spacer
            v-btn(color="primary" text :disabled="isSaveInProgress" @click="onCloseButtonClick") {{ $t('addBoarderDialog.closeButtonLabel') }}

</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Customer from '@/model/customer/Customer'
import BoarderGroup from '@/model/boarder/BoarderGroup'
import { Action } from 'vuex-class'
import {
  BOARDER_CREATE,
  BOARDER_FETCH_BOARDER_GROUP_LIST, BOARDER_MOVE_TO_GROUP,
  CUSTOMER_FETCH_CUSTOMER_LIST,
  FETCH_ARCHIVED_BOARDER_LIST, REMOVE_BOARDER_FROM_ARCHIVE
} from '@/store/action-types'
import { TranslateResult } from 'vue-i18n'
import i18n from '@/i18n'
import {BoarderGroupResponse, BoarderResponse} from '@/types/service-response'
import {CreateNewBoarderPayload, MoveBoarderToGroupPayload} from '@/types/payload'
import RemoveFromArchiveDialog from "@/components/boarder-management/RemoveFromArchiveDialog.vue";

function valueIsRequired (v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function validateEmail (v: string): boolean | TranslateResult {
  if (v) {
    return /.+@.+\..+/.test(v) || i18n.t('validation.emailMustBeValid')
  }

  return true
}

@Component({
  components: {
    RemoveFromArchiveDialog
  }
})
export default class AddBoarderDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean

  $refs!: {
    form: Vue & { validate: () => boolean }
  }

  private currentFirstName: string | null = null
  private currentFamilyName: string | null = null
  private currentEmail: string | null = null
  private currentPhoneNumber: string | null = null
  private isLoading: boolean = false
  private isSaveInProgress = false
  private customerList: Customer[] = []
  private boarderGroupList: BoarderGroup[] = []
  private currentCustomer: Customer | null = null
  private currentBoarderGroup: BoarderGroup | null = null
  private isFormValid: boolean = false
  private snackbar: boolean = false
  private snackBarText: string = ''
  private snackbarTimeout: number = 5000
  private snackbarColor: string = ''
  private archivedBoarder: any[] = []
  private name: string = ''
  private familyName: string = ''
  private selectedBoarder: any | null = null
  private inProgress: boolean = false
  private isForm1Valid: boolean = false
  private isForm2Valid: boolean = false
  private operationResult: BoarderGroupResponse | null = null
  private boarderId:string[] = []
  private tab: number | null = null
  private saveInProgress: boolean = false
  private isNameInArchive: boolean = true
  private customer: number | null  = null
  private group: number | null  = null
  private showRemoveDialog: boolean = false

  private givenNameRules = [
    valueIsRequired
  ]

  private familyNameRules = [
    valueIsRequired
  ]

  private emailRules = [
    valueIsRequired,
    validateEmail
  ]

  private currentCustomerRules = [
    valueIsRequired
  ]

  private currentBoarderGroupRules = [
    valueIsRequired
  ]

  @Action(CUSTOMER_FETCH_CUSTOMER_LIST) fetchCustomerList!: { (): Promise<Customer[]> }
  @Action(BOARDER_FETCH_BOARDER_GROUP_LIST) fetchBoarderGroupList!: { (): Promise<BoarderGroup[]> }
  @Action(FETCH_ARCHIVED_BOARDER_LIST) fetchArchivedBoarder!: { (): Promise<any[]> }
  @Action(BOARDER_CREATE) createNewBoarder!: { (payload: CreateNewBoarderPayload): Promise<BoarderResponse> }
  @Action(BOARDER_MOVE_TO_GROUP) performMove!: { (payload: MoveBoarderToGroupPayload): Promise<BoarderGroupResponse> }
  @Action(REMOVE_BOARDER_FROM_ARCHIVE) removeBoarder!: { (payload: any): Promise<any[]> }

  get isBoarderGroupSelectorDisabled (): boolean {
    return !this.currentCustomer
  }

  get boarderGroupSelectorDisabled (): boolean {
    return !this.selectedBoarder.customer.id
  }

  get filteredBoarderGroupList (): BoarderGroup[] {
    return this.boarderGroupList.filter((g) => g.customer?.id === this.currentCustomer?.id)
  }

  get filteredGroupList(): BoarderGroup[] {
    return this.boarderGroupList.filter((g) => g.customer?.id === this.customer)

  }

  get mainBodyHeight (): number | undefined {
    if (this.$vuetify.breakpoint.xs) {
      return 0
    }

    return undefined
  }

  get getfilteredArchivedBoarder():any {
    const filteredData: any = this.archivedBoarder.filter((item: any) => {
      if(item.person.firstName.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(this.name.normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '').toLowerCase()) || item.person.familyName.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(this.name.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase())){
        return item
      }
    })
    return filteredData
  }

  getList() {
    if(this.archivedBoarder && this.archivedBoarder.length < 1) {
      this.isNameInArchive = false
    }
  }

  @Watch('currentCustomer')
  onCurrentCustomerChange (newVal: Customer): void {
    if (newVal) {
      this.currentBoarderGroup = null
    }
  }

  @Watch('archiveBoarder')
  watchArchiveBoarder (newVal: any): void {
    if (newVal && newVal.length < 1) {
      this.isNameInArchive = false
    }
  }

  @Watch('tab')
  watchTab (newVal: any): void {
    if (newVal) {
      this.tab = newVal
    }
  }

  @Watch('name')
  watchName (newVal: any): void {
      this.selectedBoarder = null
      this.customer = null
      this.group = null
  }

  changeCustomer () {
    this.group = null
  }

  showBoarderFormClick(item: any) {
    if(this.$vuetify.breakpoint.smAndDown) {
      this.showRemoveDialog = true
    }
    this.selectedBoarder = item
    this.customer = this.selectedBoarder.customer.id
    this.group = this.selectedBoarder.boarderGroupCollection[0].id
  }


  onCloseButtonClick (): void {
    this.$emit('close')
  }

  onCloseDialog() {
    this.showRemoveDialog = false
  }

  saveDialog(item: number) {
    this.group = item
    this.onRemoveFromArchiveButtonClick()
  }

  async onSubmitButtonClick (): Promise<void> {
    if (this.$refs.form.validate()) {
      const payload: CreateNewBoarderPayload = {
        firstName: this.currentFirstName!,
        familyName: this.currentFamilyName!,
        emailList: [this.currentEmail!],
        phoneNumberList: this.currentPhoneNumber ? [this.currentPhoneNumber] : [],
        customer: this.currentCustomer!,
        boarderGroup: this.currentBoarderGroup!
      }
      this.isSaveInProgress = true
      try {
        const boarder = await this.createNewBoarder(payload)

        this.$emit('newBoarderCrated', boarder)

      } catch (e) {
        this.snackbarColor = "error"
        this.snackBarText = this.$t('addBoarderDialog.errorCreateNewBoarder').toString()
        this.snackbar = true
      } finally {
        this.isSaveInProgress = false
      }
    }
  }

  async updateBoarderGroup():Promise<void>{
    this.boarderId.push(this.selectedBoarder.id.toString())
    const payload: MoveBoarderToGroupPayload = {
      boarderIds: this.boarderId,
      targetBoarderGroupId:this.group ?  this.group : this.selectedBoarder.boarderGroupCollection[0].id
    }
    try {
      this.saveInProgress = true
      this.operationResult = await this.performMove(payload)
    } catch (e) {
      this.snackbarColor = "error"
      this.snackBarText = this.$t('addBoarderDialog.errorRemoveArchive').toString()
      this.snackbar = true
    } finally {
      this.saveInProgress = false
      this.showRemoveDialog = false
      this.fetchArchiveList()
      this.selectedBoarder  = null
      this.name = ''

    }
  }

  async onRemoveFromArchiveButtonClick (): Promise<void> {
    if (this.$refs.form.validate()) {
      const payload: any = {
        id: this.selectedBoarder.id
      }
      this.saveInProgress = true
      try {
        await this.removeBoarder(payload)
        this.snackbarColor = "success"
        this.snackBarText = this.$t('addBoarderDialog.removeDelete').toString()
        this.snackbar = true
      } catch (e) {
        this.snackbarColor = "error"
        this.snackBarText = this.$t('addBoarderDialog.errorRemoveArchive').toString()
        this.snackbar = true
      } finally {
        this.updateBoarderGroup()
        this.saveInProgress = false
      }
    }
  }

  async fetchArchiveList():Promise<void>{
    this.inProgress = true
    try {
      this.archivedBoarder = await this.fetchArchivedBoarder()
      this.getList()
      this.inProgress = false
    } catch (e) {
      this.snackbarColor = "error"
      this.snackBarText = this.$t('addBoarderDialog.errorFetchData').toString()
      this.snackbar = true
    }
  }

  async fetchData (): Promise<void> {
    this.isLoading = true

    const promises: Promise<Customer[] | BoarderGroup[]>[] = [
      this.fetchCustomerList(),
      this.fetchBoarderGroupList(),
    ]

    const responses = await Promise.all(promises)

    this.customerList = responses[0] as Customer[]
    this.boarderGroupList = responses[1] as BoarderGroup[]

    this.isLoading = false
  }

  mounted () {
    this.fetchData()
    this.fetchArchiveList()
    this.isNameInArchive = true
  }
}

</script>

<style lang="stylus" scoped>
.card-body
    overflow auto
</style>
